import { msg } from "@lingui/core/macro";

/**
 * Messages reused across multiple files. Sharing one descriptor keeps the
 * wording (and thus the catalog entry and its translations) from diverging.
 */
export const genericErrorMsg = msg`An error occurred. Please try again later.`;

/** After an AFib probability label, until the algorithm is certified. */
export const afibDisclaimerMsg = msg`For information only. Not yet certified (MDR Class IIa certification in progress). Not for diagnosis or treatment decisions.`;

/** Under the AFib chart: the research-use statement from db-api#620. */
export const afibResearchUseMsg = msg`For research use only. PPG is not a method for the definitive determination of clinical atrial fibrillation (AF); confirmation or exclusion of AF requires a 12-lead ECG evaluated by a physician, in accordance with the ESC guidelines for the management of atrial fibrillation.`;

/** Why a control is disabled, for features that need something the browser lacks. */
export const unsupportedByBrowserMsg = msg`Not supported by your browser`;
